import React, { useEffect, useState } from 'react';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ReactTable from 'components/ReactTable/ReactTable';
import { wsGetAll } from 'services/WService';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'Código', accessor: 'CardCode', width: 140 },
  { Header: 'Cliente', accessor: 'CardName' },
  { Header: 'Dirección', accessor: 'Address2' },
  { Header: 'Mesa', accessor: 'mesaDesc'},
  { Header: 'Estado', accessor: 'state', width: 130 , Cell: ({ value }) => ( value === 'A' ? 'Activado' : value === 'I' ? 'Inactivado' : '--' )}, 
  { Header: 'Usuario', accessor: 'userName' },
  { Header: 'Total de orden', accessor: 'total_order', width: 140 },
  { Header: 'Propiedades', accessor: 'properties' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function ClientesEstados() {
  const [loading, setLoading] = useState([]);
  const [logs, setLogs] = useState([]);
  const [filters, setFilters] = useState({});

  async function getLogs() {
    const params = new URLSearchParams();
    params.append('start_date', filters.start_date);
    params.append('end_date', filters.end_date);
    setLogs([]);
    setLoading(true);
    let res = await wsGetAll(`base/business-partner/clientes-estado?${params.toString()}`);
    setLoading(false);
    if (res.success) setLogs(res.data);
  }

  useEffect(() => {
    if (Object.keys(filters).length === 0) return;
    getLogs();
  }, [filters]);

  return (
    <CardContainer title="Mesa de clientes Activados o Inactivados">
      <FilterCustom
        dateRange
        getFilter={setFilters}
        customControl={<>{loading && <LoadingSpinner />}</>}
      />
      <ReactTable
        excelName="Consulta-clientes-Inactivados"
        defaultWidth={1000}
        formatDate="DD-MM-YYYY"
        columns={columns}
        data={logs.map((item, i) => {
          return {
            num: i + 1,
            CardCode: item.CardCode,
            CardName: item.CardName,
            Address2: item.Address2,
            mesaDesc: item.mesaDesc,
            state: item.state,
            userName: item.userName,
            properties: item.properties,
            total_order: parseFloat(item.total_order).toFixed(2),
            actions: '',
          };
        })}
      />
    </CardContainer>
  );
}

export default ClientesEstados;
